export enum IconSprites {
  ArrowDown = 'arrow-down-icon',
  ArrowRight = 'arrow-right-icon',
  BannerArrow = 'banner-arrow',
  ThinArrowDown = 'thin-arrow-down-icon',
  OpenNew = 'open-new-icon',
  Menu = 'menu-icon',
  Close = 'close-icon',
  SuperhumanMailWithBg = 'superhuman-mail-with-background-icon',
  GrammarlyBubble = 'grammarly-bubble-icon',
  GrammarlyLogo = 'grammarly-logo-icon',
  CodaLogo = 'coda-logo-icon',
  GoLogo = 'go-logo-icon',
  Grammarly = 'grammarly-icon',
  Go = 'go-icon',
  Mail = 'mail-icon',
  Coda = 'coda-icon',
  HeroOutline = 'hero-outline-icon',
  ReaderReactions = 'reader-reactions-icon',
  Sparkle = 'sparkle-icon',
  Humanizer = 'humanizer-icon',
  CitationFinder = 'citation-finder-icon',
  Calendar = 'calendar-icon',
  Recording = 'recording-icon',
  Send = 'send-icon',
  Hero = 'hero-icon',
  Home = 'home-icon',
  Comment = 'comment-icon',
  Gear = 'gear-icon',
  Font = 'font-icon',
  Bold = 'bold-icon',
  Italic = 'italic-icon',
  Underline = 'underline-icon',
  Strikethrough = 'strikethrough-icon',
  AlignStart = 'align-start-icon',
  Info = 'info',
  CheckMark = 'check-mark',

  // Social Media
  LinkedIn = 'linkedin-icon',
  X = 'x-icon',
  TikTok = 'tiktok-icon',
  Instagram = 'instagram-icon',
  Threads = 'threads-icon',
  Facebook = 'facebook-icon',
}

export enum LogoSprites {
  Superhuman = 'superhuman-logo',
}
